/**
 * Model class to maintain payload, which will contain all the info related to dwell time.
 * Instance for this payload will be created when dwell time starts.
 */
var DwellTimeInfo = /** @class */ (function () {
    function DwellTimeInfo(pageId, impressionId, parentImpressionId, type, pageType, widgetType, widgetViewType, widgetTitle, widgetCategory, moduleId, contentType) {
        this.pageId = pageId;
        this.impressionId = impressionId;
        this.parentImpressionId = parentImpressionId;
        this.pageType = pageType;
        this.startTime = Date.now();
        this.inactivityTime = 0;
        this.endTime = -1;
        this.type = type;
        this.widgetType = widgetType;
        this.widgetViewType = widgetViewType;
        this.widgetTitle = widgetTitle;
        this.widgetCategory = widgetCategory;
        this.moduleId = moduleId;
        this.contentType = contentType;
    }
    return DwellTimeInfo;
}());
export default DwellTimeInfo;
